import type { ScmProviderId } from '@/types/scm-provider';
import type { ReleaseDefinitionEnvironments } from '@/components/smartai/api/getReleaseEnvironments';
import type { ReleasePipelineSelection } from '@/components/smartai/api/getScriptCandidates';

export type ResourceOption = { value: string; label: string };

/** Minimal ADO repo fields required by detect/onboard API. */
export type AdoDetectRepository = {
  id: string;
  name: string;
  url?: string;
  remoteUrl?: string;
  defaultBranch?: string;
  size?: number;
};

export type AddRepositoryPickSelections = {
  provider: ScmProviderId;
  organization: string;
  organizationAccountId?: string;
  organizationAccountUri?: string;
  pat: string;
  selectedProject: string;
  /** ADO project GUID (distinct from display name). */
  selectedProjectId?: string;
  selectedRepo: string;
  selectedRepoName: string;
  repoRemoteUrl: string;
  /** Selected ADO repo payload for detect/onboard (app repo). */
  selectedRepoDetectData?: AdoDetectRepository;
  selectedBranch: string;
  /** ADO branch tip commit SHA (`objectId` from branches API). */
  selectedBranchObjectId?: string;
  selectedPipeline: string;
  selectedPipelineName: string;
  selectedStage: string;
  selectedReleases: string[];
  releasePipelineLabels: Record<string, string>;
  selectedWorkflow: string;
  selectedWorkflowName: string;
  selectedJob: string;
  selectedEnvironments: string[];
  scanOnly: boolean;
  frontendUrl: string;
  backendUrl: string;
  applicationPrEmails: string[];
  automationPrEmails: string[];
  captureBeforeAfter: boolean;
};

export function buildReleaseSelectionsFromEnvironments(
  defs: ReleaseDefinitionEnvironments[],
): ReleasePipelineSelection[] {
  return defs.map(def => {
    const withHint = (def.environments ?? []).filter(env => env.hasKatalonHint);
    const pick = withHint.length ? withHint : (def.environments ?? []);
    const envNames = pick.map(env => env.name).filter(Boolean);
    return {
      releaseDefinitionId: def.releaseDefinitionId,
      releasePipelineName: def.releasePipelineName,
      environmentNames: envNames.length ? envNames : undefined,
    };
  });
}
